import { FormField } from 'ui/formField';
import { InputField } from 'lib/iterable-hook-form';
import { useFormContext, useFormState } from 'react-hook-form';
import type { AuthedEmailEditFormProps } from '../types';
import type { AuthedEmailEditFormContextType } from '../contexts/AuthedEmailEditFormProvider';

export const AuthedEmailEditForm = ({ formId, onSubmit }: AuthedEmailEditFormProps) => {
  const { handleSubmit } = useFormContext<AuthedEmailEditFormContextType>();
  const { errors } = useFormState<AuthedEmailEditFormContextType>();

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <FormField
        errorText={errors.senderName?.message}
        hasError={!!errors.senderName?.message}
        inputId="senderNameFormFieldId"
        labelText="From name"
      >
        <InputField
          id="senderNameFormFieldId"
          name="senderName"
          data-test="edit-sender-senderName-field"
          autoFocus
        />
      </FormField>
      <FormField
        errorText={errors.defaultReplyTo?.message}
        hasError={!!errors.defaultReplyTo?.message}
        inputId="defaultReplyToFormFieldId"
        labelText="Default reply-to"
      >
        <InputField
          id="defaultReplyToFormFieldId"
          name="defaultReplyTo"
          data-test="edit-sender-defaultReplyTo-field"
        />
      </FormField>
    </form>
  );
};
